import { Link } from 'react-router-dom';
import { useSiteData } from '@/data/siteData';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import VehicleCard from './VehicleCard';

export default function VehiclesSection() {
  const { ref, isVisible } = useScrollAnimation(0.1);
  const { vehicles, loading } = useSiteData();
  const homeVehicles = vehicles.slice(0, 6);

  return (
    <section id="vehicules" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div ref={ref} className={`text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            Nos véhicules d'occasion
          </h2>
          <p className="text-foreground-600 mt-3 max-w-xl mx-auto text-sm md:text-base">
            Découvrez notre sélection de véhicules disponibles dans nos parcs. Contactez-nous pour plus d'informations.
          </p>
        </div>

        {loading ? (
          <p className="text-center text-foreground-500 mt-8">Chargement des véhicules…</p>
        ) : homeVehicles.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-8 md:mt-10">
            {homeVehicles.map((vehicle, idx) => (
              <VehicleCard key={vehicle.id} vehicle={vehicle} index={idx} />
            ))}
          </div>
        ) : (
          <p className="text-center text-foreground-500 mt-8">Aucun véhicule publié pour le moment.</p>
        )}

        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/vehicules"
            className="inline-block px-6 py-3 rounded-md bg-primary-500 text-white font-label font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            Voir tous nos véhicules
          </Link>
        </div>
      </div>
    </section>
  );
}
